import { getUserData } from '@/api';
import { acceptTerms } from '@/core';
import { getUserAttributes, setUserAttributes, updateLoginState } from '@/util';
import { CognitoUser } from 'amazon-cognito-identity-js';

export const startUserSession = () => {
  getUserData().then((_) => {
    updateLoginState('/');
  });
}

export const postVerificationActions = (user: any, date: Date) => {
  acceptTerms(user, date);
  setUserAttributes(getUserAttributes(user.attributes));
  startUserSession();
}

export const isSessionValid = (user: CognitoUser): boolean => {
  try {
    const session = user.getSignInUserSession();
    return !!session && session.isValid();
  } catch {
    return false;
  }
}
